import type { IncidentV2SortField } from '@elementary/common-ui/services/gql/types';

export const NO_ASSIGNEE_VALUE = 'no_assignee';
export const LINEAGE_GROUPING_STRATEGY = 'lineage';
export const COLUMN_TO_INCIDENT_FIELD_MAP: Record<string, string> = {
  severity: 'SEVERITY',
  assignee: 'ASSIGNEE',
  status: 'STATUS',
  database: 'DB',
  schema: 'SCHEMA',
  asset_name: 'ASSET_NAME',
  monitor_type: 'MONITOR_TYPE',
  grouping_strategy: 'GROUPING_STRATEGY',
};

export const INCIDENT_COLUMN_TO_SORT_FIELD: Record<
  string,
  IncidentV2SortField
> = {
  severity: 'SEVERITY_RANK',
  start_time: 'CREATED_AT',
  last_event: 'LAST_FAILURE_TIME',
  monitors: 'MONITOR_COUNT',
  assignee: 'ASSIGNEE',
  status: 'STATUS_RANK',
  tickets: 'TICKET_COUNT',
  database: 'DB',
  schema: 'SCHEMA',
  asset_name: 'ASSET_NAME',
};

export const GROUPING_STRATEGY_COLUMN_ID = 'grouping_strategy';
export const STATUS_COLUMN_ID = 'status';
export const SEVERITY_COLUMN_ID = 'severity';
export const ASSIGNEE_COLUMN_ID = 'assignee';

export const RESOLVED_STATUS = 'Resolved';

export const STATUS_GROUP_VALUES = [
  'Open',
  'Acknowledged',
  RESOLVED_STATUS,
] as const;

export const SEVERITY_DISPLAY: Record<string, string> = {
  low: 'Low',
  normal: 'Normal',
  high: 'High',
  critical: 'Critical',
};

export const STATUS_DISPLAY: Record<string, string> = {
  open: 'Open',
  acknowledged: 'Acknowledged',
  resolved: 'Resolved',
};

export const GROUPING_STRATEGY_DISPLAY: Record<string, string> = {
  freshness: 'Freshness issues',
  asset_failure_freshness: 'Asset run errors',
  similar_errors: 'Similar test errors',
  [LINEAGE_GROUPING_STRATEGY]: 'Tests connected by lineage',
  one_to_one: 'Ungrouped',
  manual: 'Manual merge',
  ai_agent: 'AI agent',
  mcp_tool: 'MCP',
};
